import _uniq from 'lodash/uniq';

import { FLOW_STEP_PATHS } from '@/constants';

import { ApplicationChecking, ApplicationCheckingV2 } from '@/containers/ApplicationChecking';
import { ApplicationReview } from '@/containers/ApplicationReview';
import ApplicationSuccess from '@/containers/ApplicationSuccess';

import {
  isApplicationSubmitted,
  isMerchantTransactionsEnabled,
  isMerchantTransactionsReviewAutomatedOrManual,
} from '@/flow/configs/selectors';
import { getAfterFlowStep } from '@/flow/configs/merchant-application/common';

export class ReviewBlock {
  constructor({ isManagedFlow, isUnmanagedKyc, isWidget, prerequisite = [] }) {
    this.isManagedFlow = isManagedFlow;
    this.isUnmanagedKyc = isUnmanagedKyc;
    this.isWidget = isWidget;
    this.prerequisite = prerequisite;
  }

  static selectors = {
    isApplicationSubmitted,
    isMerchantTransactionsEnabled,
    isMerchantTransactionsReviewAutomatedOrManual,
  };

  getSelectors() {
    return ReviewBlock.selectors;
  }

  withGlobalPrerequisites(prerequisite = []) {
    return _uniq([...prerequisite, ...(this.prerequisite || [])]);
  }

  generateFlowConfig() {
    return [
      {
        id: 'application-checking',
        path: FLOW_STEP_PATHS.APPLICATION_CHECKING_PATH,
        prerequisite: this.withGlobalPrerequisites([
          'isMerchantTransactionsReviewAutomatedOrManual',
        ]),
        Container:
          this.isUnmanagedKyc && this.isWidget ? ApplicationCheckingV2 : ApplicationChecking,
        exclude: this.isManagedFlow,
        back: FLOW_STEP_PATHS.APPLICATION_CONFIRMATION_PATH,
        next: [
          {
            condition:
              this.isUnmanagedKyc && this.isWidget ? false : 'isMerchantTransactionsEnabled',
            path: FLOW_STEP_PATHS.APPLICATION_SUCCESS_PATH,
          },
          {
            condition: 'isApplicationSubmitted',
            path: getAfterFlowStep({
              isUnmanagedKyc: this.isUnmanagedKyc,
              isWidget: this.isWidget,
            }),
          },
        ],
        extraProps: { excludeFromProgressIndicator: true },
      },
      {
        id: 'application-review',
        prerequisite: this.withGlobalPrerequisites(['isApplicationSubmitted']),
        path: FLOW_STEP_PATHS.APPLICATION_REVIEW,
        Container: ApplicationReview,
        exclude: !(this.isUnmanagedKyc && this.isWidget),
        back: FLOW_STEP_PATHS.APPLICATION_CHECKING_PATH,
        next: false,
      },
      {
        id: 'application-success',
        path: FLOW_STEP_PATHS.APPLICATION_SUCCESS_PATH,
        prerequisite: this.withGlobalPrerequisites(['isMerchantTransactionsEnabled']),
        Container: ApplicationSuccess,
        exclude: this.isUnmanagedKyc && this.isWidget,
        back: FLOW_STEP_PATHS.APPLICATION_CHECKING_PATH,
        next: getAfterFlowStep({ isUnmanagedKyc: this.isUnmanagedKyc, isWidget: this.isWidget }),
        extraProps: { excludeFromProgressIndicator: true },
      },
    ];
  }
}
